<template>
  <RegisterLayout>
    <template #title>
      Анкета
    </template>
    <template #description>
      Заполните анкету и наш менеджер свяжется с Вами
    </template>
    <el-form class="register__form">
      <el-row :gutter="16">
        <el-col>
          <el-form-item prop="first_name" :error="errors.first_name">
            <label>
              <span>Имя</span>
              <el-input v-model="formData.first_name" size="small" />
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="last_name" :error="errors.last_name">
            <label>
              <span>Фамилия</span>
              <el-input v-model="formData.last_name" size="small" />
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="middle_name" :error="errors.middle_name">
            <label>
              <span>Отчество</span>
              <el-input v-model="formData.middle_name" size="small" placeholder="При наличии" />
            </label>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="day" :error="errors.day">
            <label>
              <span>Дата рождения</span>
              <el-select v-model="formData.day" size="small" placeholder="Число">
                <el-option v-for="day in days" :key="day" :label="day" :value="day" />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="month" :error="errors.month">
            <label>
              <span>{{ '\u200B' }}</span>
              <el-select v-model="formData.month" size="small" placeholder="Месяц">
                <el-option
                  v-for="(month, value) in months"
                  :key="month"
                  :label="month"
                  :value="value"
                />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="your" :error="errors.your">
            <label>
              <span>{{ '\u200B' }}</span>
              <el-select v-model="formData.your" size="small" placeholder="Год">
                <el-option v-for="your in yours" :key="your" :label="1901 + your" :value="your" />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="country" :error="errors.country">
            <label>
              <span>Страна</span>
              <el-select v-model="formData.country" size="small">
                <el-option
                  v-for="(country, index) in countries"
                  :key="index"
                  :label="country"
                  :value="country"
                />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="skype" :error="errors.skype">
            <label>
              <span>Skype</span>
              <el-input v-model="formData.skype" size="small" placeholder="Не обязательно" />
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="profession" :error="errors.profession">
            <label>
              <span>Будущая профессия</span>
              <el-select v-model="formData.profession" size="small">
                <el-option
                  v-for="(profession, index) in professions"
                  :key="index"
                  :label="profession"
                  :value="profession"
                />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="time" :error="errors.time">
            <label>
              <span>Удобное время для консультации</span>
              <el-time-picker v-model="formData.time" size="small" :editable="false" />
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="communication" :error="errors.communication">
            <label>
              <span>Форма связки</span>
              <el-select v-model="formData.communication" size="small">
                <el-option
                  v-for="(communication, index) in communications"
                  :key="index"
                  :label="communication"
                  :value="communication"
                />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="lang_select" :error="errors.lang_select">
            <label>
              <span>Язык для консультации</span>
              <el-select v-model="formData.lang_select" size="small">
                <el-option
                  v-for="(lang, index) in langs"
                  :key="index"
                  :label="lang"
                  :value="index"
                />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col v-if="+formData.lang_select === 7">
          <el-form-item prop="lang_custom" :error="errors.lang_custom">
            <label>
              <span>Введите свой вариант</span>
              <el-input v-model="formData.source_custom" size="small" />
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="source_select" :error="errors.source_select">
            <label>
              <span>Как вы узнали о РУДН</span>
              <el-select v-model="formData.source_select" size="small">
                <el-option
                  v-for="(source, index) in sources"
                  :key="index"
                  :label="source"
                  :value="index"
                />
              </el-select>
            </label>
          </el-form-item>
        </el-col>
        <el-col v-if="+formData.source_select === 4">
          <el-form-item prop="source_custom" :error="errors.source_custom">
            <label>
              <span>Введите свой вариант</span>
              <el-input v-model="formData.source_custom" type="textarea" />
            </label>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="agreement" :error="errors.agreement" class="register__agreement">
            <el-checkbox v-model="formData.agreement">
              Нажимая «Отправить», я подтверждаю, что лично ознакомился с Положением об обработке
              персональных данных, вправе предоставлять свои персональные данные и давать согласие
              на их обработку. Предоставляя свои персональные данные, принимаю
              <router-link to="/">условия</router-link> этого Положения, подтверждаю, что они
              относятся ко мне, являются точными и актуальными, тем самым свободно, своей волей и в
              своем интересе распоряжаюсь ими, осознаю последствия их предоставления и выражаю свое
              согласие на их обработку в соответствии с
              <router-link to="/"
                >пунктом 3.7 Положения об обработке персональных данных.</router-link
              >
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item class="register__submit">
            <el-button type="success" size="small" @click="isVisibleSuccess = true">
              Отправить запрос
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <RegisterStepOneModal :visible.sync="isVisibleSuccess" />
  </RegisterLayout>
</template>

<script>
import RegisterLayout from '@/components/Auth/RegisterLayout'
import DateSelect from '@/assets/mixins/date-select'
import RegisterStepOneModal from '@/components/Auth/RegisterStepOneModal'

export default {
  mixins: [DateSelect],
  name: 'StepOne',
  components: { RegisterStepOneModal, RegisterLayout },
  data: () => ({
    isVisibleSuccess: false,

    formData: {
      first_name: '',
      last_name: '',
      middle_name: '',
      day: '',
      month: '',
      your: '',
      country: '',
      profession: '',
      skype: '',
      time: '',
      communication: '',
      lang_select: '',
      source_select: '',
      source_custom: '',
      agreement: false,
      lang_custom: ''
    },

    communications: ['Аудиозвонок', 'Видеозвонок'],

    langs: {
      1: 'Русский',
      2: 'Английский',
      3: 'Испанский',
      4: 'Французский',
      5: 'Арабский',
      6: 'Китайский',
      7: 'Другое'
    },

    professions: ['Повар', 'Программист', 'Сварщик'],

    countries: ['Россия', 'Украина', 'Беларусь', 'Германия'],

    sources: {
      1: 'Увидел информацию на сайте вуза',
      2: 'Увидел рекламу в стране от партнеров Цифрового подготовительного факультета',
      3: 'Узнал от знакомых',
      4: 'Другое'
    },

    errors: {
      first_name: '',
      last_name: '',
      middle_name: '',
      day: '',
      month: '',
      your: '',
      country: '',
      profession: '',
      skype: '',
      time: '',
      communication: '',
      lang_custom: '',
      source_select: '',
      source_custom: '',
      agreement: '',
      lang_select: ''
    }
  })
}
</script>

<style scoped lang="scss">
.register {
  &__form {
    width: 390px;

    @include sm-and-down {
      width: 100%;
    }
  }

  &__agreement {
    &::v-deep .el-form-item__content .el-checkbox {
      align-items: flex-start;
      flex-direction: row;

      &__label {
        white-space: normal;
        display: block;
        font-size: 12px;
        line-height: 14px;
        color: $deepdark;
        font-weight: normal;
        padding: 0;
        margin-left: 8px;

        a {
          color: $luchmara;
          text-decoration: underline;
        }
      }
    }
  }

  &__submit {
    &::v-deep .el-form-item__content {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
